import { FormValuesRegister, LoginPayload, RegisterPayload } from 'models/authModel';
import { useEffect, useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import styles from './register.style';
import CheckBox from 'components/checkbox/CheckBox';
import { msgAlertInput } from 'constants/messageAlert';
import authApi from 'apis/authApi';
import { DEVICE_INFO } from 'constants/common';
import { logoPartnerList } from 'constants/logoPartner';
import { cacheTokenBC, cacheTokenRH, cacheTokenXD, cacheUserInfo, login, rememberAccountAction, updateAgentType } from 'features/authSlice';
import { useAppDispatch } from 'cache/store';
import { encode } from 'punycode';
import LoadingIcon from 'components/loading/LoadingIcon';
import { useNavigate, useParams } from 'react-router-dom';
import Fingerprint2 from 'fingerprintjs2';
import { VERSION } from 'config/app.config';
import useQueryUrl from 'utils/useQuery';
import bcMiniGameApi from 'apis/bc-minigame-api';
import xdMiniGameApi from 'apis/xd-minigame-api';
import rongHoApi from 'apis/rongho-api';

type InputId = 'un' | 'pwd' | 'zjpwd' | 'nickname' | 'phone' | 'email';
interface InputItem {
    id: InputId;
    label: string;
    holder: string;
    inputType: string;
    require: boolean;
    togglePass?: boolean;
    pattern?: { value: RegExp; message: string };
    minLength?: { value: number; message: string };
    maxLength?: { value: number; message: string };
}
const listInput: InputItem[] = [
    {
        id: 'un',
        label: 'Tên Đăng Nhập',
        holder: msgAlertInput.username.invalid,
        inputType: 'text',
        require: true,
        pattern: {
            value: /^\S+$/,
            message: msgAlertInput.generic.invalid('Tên đăng nhập'),
        },

        maxLength: {
            value: 30,
            message: msgAlertInput.generic.maxLength(30),
        },
    },
    {
        id: 'pwd',
        label: 'Mật Khẩu',
        holder: msgAlertInput.password.invalid,
        inputType: 'password',
        require: true,
        togglePass: true,
        maxLength: {
            value: 30,
            message: msgAlertInput.generic.maxLength(30),
        },
    },
    // {
    //     id: 'zjpwd',
    //     label: 'Mật Khẩu Thanh Toán',
    //     holder: msgAlertInput.password.invalid,
    //     inputType: 'password',
    //     require: true,
    //     togglePass: true,
    //     maxLength: {
    //         value: 30,
    //         message: msgAlertInput.generic.maxLength(30),
    //     },
    // },
    {
        id: 'phone',
        label: 'Số Điện Thoại',
        holder: 'Nhập vào số điện thoại',
        inputType: 'text',
        require: true,
        maxLength: {
            value: 12,
            message: msgAlertInput.generic.maxLength(12),
        },
    },
];

function Register() {
    const { id } = useParams<{ id: string }>();
    const dispatch = useAppDispatch();
    const [isCheckedTOF, setIsCheckedTOF] = useState(false);
    const [showPass, setShowPass] = useState(false);
    const [showPassPay, setShowPassPay] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const {
        handleSubmit,
        register,
        setFocus,
        setError,
        formState: { errors },
    } = useForm<FormValuesRegister>();

    const handleRegister: SubmitHandler<FormValuesRegister> = async (values) => {
        // const validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        // if(values.email !== '' && (!values.email.match(validRegex))) {
        //     toast.error('Vui lòng nhập đúng định dạng email');
        //     return;
        // }
        if (!isCheckedTOF) {
            toast.error('Vui lòng chọn chấp nhận các điều khoản');
            return;
        }
        // if (values.pwd === values.zjpwd) {
        //     setFocus('zjpwd');
        //     setError('zjpwd', {
        //         type: 'value',
        //         message: 'Mật khẩu thanh toán không được giống với đăng nhập',
        //     });
        //     return;
        // }
        const payload = {
            ...values,
            nickname: values.un.toLowerCase(),
            loginname: values.un.toLowerCase(),
            email: values.email || `${values.un.toLowerCase().trim()}_noreply@gmail.com`,
            agentid: '8890',
            id: id || '9550',
        };
        onRegister(payload);
    };

    useEffect(() => {
        if ((window as any).requestIdleCallback) {
            requestIdleCallback(function () {
                Fingerprint2.get(function (components) {
                    getFingerPrint(components);
                });
            });
        } else {
            setTimeout(function () {
                Fingerprint2.get(function (components) {
                    getFingerPrint(components);
                });
            }, 500);
        }
    }, []);

    const loginMiniGameBC = async (payload: { password: string; rememberMe: boolean, username: string }) => {
        try {
            const { data } = await bcMiniGameApi.getToken(payload);
            dispatch(cacheTokenBC(data.id_token));
        } catch (error) {
            console.log(error);
        }
      };
    
      const loginMiniGameXD = async (payload: { password: string; rememberMe: boolean, username: string }) => {
        try {
            const { data } = await xdMiniGameApi.getToken(payload);
            dispatch(cacheTokenXD(data.id_token));
        } catch (error) {
            console.log(error);
        }
      };
    
      const loginMiniGameRH = async (payload: { password: string; rememberMe: boolean, username: string }) => {
        try {
            const { data } = await rongHoApi.getTokenRH(payload);
            dispatch(cacheTokenRH(data.id_token));
        } catch (error) {
            console.log(error);
        }
      };

    const getFingerPrint = (components: Fingerprint2.Component[]) => {
        const values = components.map((component) => {
            return component.value;
        });
        DEVICE_INFO.uuid = Fingerprint2.x64hash128(values.join(''), 88);
        DEVICE_INFO.timezone = values[9];
        DEVICE_INFO.platform = values[16];
        DEVICE_INFO.resolution = values[6].join('x');
    };

    const onRegister = async (values: RegisterPayload) => {
        setLoading(true);
        try {
            const { data } = await authApi.signUp(values);
            if (!data.msg) {
                //thông báo đăng ký tài khoản thành công
                toast.success('Đăng ký tài khoản khoản thành công');

                //login account khi đăng ký tài khoản thành công
                const payloadLogin = {
                    un: values.un,
                    pwd: values.pwd,
                    ver: VERSION,
                    di: DEVICE_INFO,
                };

                //call login from header component
                submitLogin(payloadLogin, true, false);
            } else {
                toast.error(data.msg);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const submitLogin = async (payload: LoginPayload, showAlertSuccess: boolean, rememberAccount?: boolean) => {
        const { un, pwd } = payload;
        try {
            const { data } = await authApi.login(payload);
            if (data.msg === '') {
                //change state logged in store "auth slice"
                dispatch(login(true));

                if (showAlertSuccess) {
                    toast.success('Đăng nhập thành công!');

                    loginMiniGameBC({ password: payload.pwd, rememberMe: false, username: payload.un });
                    loginMiniGameXD({ password: payload.pwd, rememberMe: false, username: payload.un });
                    loginMiniGameRH({ password: payload.pwd, rememberMe: false, username: payload.un });
                }

                //cache userinfo to store "auth slice"
                dispatch(cacheUserInfo(data.user));

                //cache agent type account
                let agentTypeUser = null;
                if (data.user.usertype === -2) {
                    agentTypeUser = 1;
                } else if (data.user['param9'] && data.user['param9'] !== '') {
                    agentTypeUser = 2;
                }
                dispatch(updateAgentType(agentTypeUser));

                //cache remember account
                if (rememberAccount) {
                    const rememberData = {
                        account: encode(`${un}|${pwd}`),
                        isRemember: true,
                    };
                    dispatch(rememberAccountAction(rememberData));
                } else {
                    dispatch(rememberAccountAction({ isRemember: false, account: null }));
                }
            } else {
                toast.error(data.msg);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setTimeout(() => {
                navigate('/');
                setLoading(false);
            }, 2000);
        }
    };

    return (
        <>
            <div className={styles.wrap}>
                <div className="page-content">
                    <div className={styles.left}>
                        <img src={require('assets/images/bg/register.jpg')} alt="" />
                        <div className={styles.logoPartner}>
                            {logoPartnerList.map((item, index) => (
                                <div className={styles.partnerItem} key={index}>
                                    <div className={styles.itemInner}>
                                        <img src={item} alt="" />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className={styles.contentform}>
                        <div className={styles.titleReg}>
                            <h6>ĐĂNG KÝ</h6>
                            <img src={require('assets/images/logos/logo.png')} alt="" onClick={() => navigate('/')} />
                        </div>
                        <form className={styles.form} onSubmit={handleSubmit(handleRegister)}>
                            {listInput.map((item, index) => (
                                <div className={styles.inputWrap} key={index}>
                                    <label htmlFor={item.id}>{item.label}</label>
                                    <input
                                        type={item.id === 'pwd' ? (!showPass ? item.inputType : 'text') : item.id === 'zjpwd' ? (!showPassPay ? item.inputType : 'text') : item.inputType}
                                        id={item.id}
                                        placeholder={item.holder}
                                        className={`input-common ${styles.input}`}
                                        {...register(item.id, {
                                            required: item.require,
                                            pattern: item.pattern,
                                            maxLength: item.maxLength,
                                            minLength: item.minLength,
                                        })}
                                    />
                                    {/* toggle password login */}
                                    {item.togglePass && item.id === 'pwd' && (
                                        <div className={styles.togglePass} onClick={() => setShowPass(!showPass)}>
                                            {showPass ? <img src={require('assets/images/icons/eye_on.png')} alt="" /> : <img src={require('assets/images/icons/eye_off.png')} alt="" />}
                                        </div>
                                    )}

                                    {/* toggle password pay */}
                                    {item.togglePass && item.id === 'zjpwd' && (
                                        <div className={styles.togglePass} onClick={() => setShowPassPay(!showPassPay)}>
                                            {showPassPay ? <img src={require('assets/images/icons/eye_on.png')} alt="" /> : <img src={require('assets/images/icons/eye_off.png')} alt="" />}
                                        </div>
                                    )}

                                    {/* base error  */}
                                    <div className={styles.errorInput}>{(errors as any)[item.id] && <small>{(errors as any)[item.id].message || 'Vui lòng nhập trường này!'}</small>}</div>
                                </div>
                            ))}
                            <div className={styles.checkbox}>
                                <CheckBox isChecked={isCheckedTOF} onToggleCheck={(value) => setIsCheckedTOF(value)}>
                                    <p className={styles.textTOF}>
                                        Tôi đã đọc và đồng ý với các <span onClick={() => navigate('/help?view=1')}>Điều khoản và Điều kiện</span> của 188LUX
                                    </p>
                                </CheckBox>
                                <button type="submit" className={styles.btnPrimary} style={{ marginTop: '24px' }}>
                                    Đăng Ký
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            {loading && <LoadingIcon />}
        </>
    );
}

export default Register;
